import React, { useCallback } from 'react';
import classNames from 'classnames';
import objectPath from 'object-path';

import { CheckIcon, LockClosedIcon, ExclamationIcon } from '@heroicons/react/outline';

import journeyVectorLogo from 'src/icons/journey-logo-vector.svg';

import { ClearbitLogo } from 'src/common/ClearbitLogo';
import { isPlaceholderNode, isJourneyUpsellNode } from '../utils/journey';
import nodeLogos from '../utils/nodeLogos';
import nodeIcons from '../utils/nodeIcons';

function ContentTypeLogo({ node, completed, locked, className = '', showGenericIcon, iconWeight = 'strong' }) {
  const contentType = node.content_type;
  const nodeLogo = nodeLogos[contentType];
  const NodeIcon = nodeIcons[contentType]?.[iconWeight === 'regular' ? 'regular' : 'strong'];

  const classes = classNames('flex-shrink-0', className);

  const renderLogo = useCallback(() => {
    if (nodeLogo) {
      return nodeLogo;
    }

    if (!showGenericIcon) {
      const embedHost = objectPath.get(node, 'embed.destination.host', null);

      if (embedHost) {
        const host = embedHost.split('.')[0];
        const hostLogo = nodeLogos[host] || nodeLogos[embedHost];

        if (hostLogo) {
          return hostLogo;
        }

        return <ClearbitLogo host={embedHost} classes={classes} />;
      }
    }

    if (NodeIcon) {
      return <NodeIcon className={classes} />;
    }

    return null;
  }, [nodeLogo, showGenericIcon, node, NodeIcon, classes]);

  if (isJourneyUpsellNode(node)) {
    return <img src={journeyVectorLogo} alt='Journey logo' classes={classes} />;
  }

  if (isPlaceholderNode(node)) {
    return <ExclamationIcon className={classes} />;
  }

  if (locked) {
    return <LockClosedIcon className={classes} />;
  }

  if (completed) {
    return <CheckIcon className={classes} />;
  }

  return renderLogo();
}

ContentTypeLogo.defaultProps = {
  type: '',
  logoUrl: '',
  showIntegrationIcon: false,
  showGenericIcon: false,
  completed: false,
  locked: false,
};

export default ContentTypeLogo;
